<template>
  <b-card class="pending-followups" v-if="hasRight(user, 'dashboard', 'view')" no-body>
    <template #header>
      <h6 class="mb-0">Upcoming Follow-ups</h6>
    </template>
    <b-card-body>
      <b-table :items="followups" :fields="fields" per-page="5" small striped responsive></b-table>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BTable } from 'bootstrap-vue';
import { hasRight } from '@/utils/auth';
import { dashboardGet } from './dashboardApi';
import moment from 'moment';

export default {
  name: 'PendingFollowups',
  components: {
    BCard,
    BCardBody,
    BTable,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
    dashboardData: { type: Object, default: null },
    useAggregate: { type: Boolean, default: false },
    baseApi: {
      type: String,
      default: () => process.env.VUE_APP_APIENDPOINT || '',
    },
    accessToken: {
      type: String,
      default: () => localStorage.getItem('accessToken') || '',
    },
  },

  data() {

    return {

      fields: [
        { key: 'lead_name', label: 'Lead Name' },
        { key: 'nextfollowupdate', label: 'Follow-up Date' },
        { key: 'remarks', label: 'Remarks' },
      ],
      followups: [],

    };

  },

  watch: {
    dashboardData: {
      deep: true,
      handler(val) {
        if (val && val.pending_followups != null && hasRight(this.user, 'dashboard', 'view')) {
          const arr = Array.isArray(val.pending_followups) ? val.pending_followups : [];
          this.followups = arr.map(f => ({
            ...f,
            nextfollowupdate: f.nextfollowupdate ? moment(f.nextfollowupdate).format('DD-MM-YYYY HH:mm') : (f.nextfollowupdate || ''),
          }));
        }
      },
    },
    filters: {
      deep: true,
      immediate: true,
      handler() {
        if (!hasRight(this.user, 'dashboard', 'view')) return;
        if (this.useAggregate) {
          if (this.dashboardData && this.dashboardData.pending_followups != null) {
            const arr = Array.isArray(this.dashboardData.pending_followups) ? this.dashboardData.pending_followups : [];
            this.followups = arr.map(f => ({ ...f, nextfollowupdate: f.nextfollowupdate ? moment(f.nextfollowupdate).format('DD-MM-YYYY HH:mm') : (f.nextfollowupdate || '') }));
          }
          return;
        }
        if (this.dashboardData && this.dashboardData.pending_followups != null) {
          const arr = Array.isArray(this.dashboardData.pending_followups) ? this.dashboardData.pending_followups : [];
          this.followups = arr.map(f => ({ ...f, nextfollowupdate: f.nextfollowupdate ? moment(f.nextfollowupdate).format('DD-MM-YYYY HH:mm') : (f.nextfollowupdate || '') }));
          return;
        }
        this.fetchPendingFollowupsData();
      },
    },
    user: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (hasRight(newVal, 'dashboard', 'view')) {
          if (this.useAggregate) {
            if (this.dashboardData && this.dashboardData.pending_followups != null) {
              const arr = Array.isArray(this.dashboardData.pending_followups) ? this.dashboardData.pending_followups : [];
              this.followups = arr.map(f => ({ ...f, nextfollowupdate: f.nextfollowupdate ? moment(f.nextfollowupdate).format('DD-MM-YYYY HH:mm') : (f.nextfollowupdate || '') }));
            }
            return;
          }
          this.fetchPendingFollowupsData();
        } else {
          this.followups = [];
        }
      },
    },
  },

  methods: {

    hasRight, // Make the helper available in the template

    async fetchPendingFollowupsData() {
      if (!hasRight(this.user, 'dashboard', 'view')) return;
      if (this.useAggregate || (this.dashboardData && this.dashboardData.pending_followups != null)) {
        if (this.dashboardData && this.dashboardData.pending_followups != null) {
          const arr = Array.isArray(this.dashboardData.pending_followups) ? this.dashboardData.pending_followups : [];
          this.followups = arr.map(f => ({ ...f, nextfollowupdate: f.nextfollowupdate ? moment(f.nextfollowupdate).format('DD-MM-YYYY HH:mm') : (f.nextfollowupdate || '') }));
        }
        return;
      }
      try {
        const response = await dashboardGet(this.baseApi, this.accessToken, '/dashboard/crm/pending-followups', this.filters);
        const raw = response.data && response.data.data;
        const arr = Array.isArray(raw) ? raw : [];
        this.followups = arr.map(f => ({ ...f, nextfollowupdate: f.nextfollowupdate ? moment(f.nextfollowupdate).format('DD-MM-YYYY HH:mm') : (f.nextfollowupdate || '') }));

      } catch (error) {

        console.error('Error fetching pending follow-ups data:', error);

        // Handle error

      }

    },

  },

};

</script>



<style scoped>

.pending-followups {

  margin-top: 20px;

}

</style>